module.exports = __webpack_public_path__ + "img/event8.10bad0fa.png";